import { z } from 'zod';
import { Status } from '@anchorbase/pillar-sdk';

export interface IsoFormData {
    name: string;
    parent_organization_uuid?: string;
}

export const isoSchema: z.ZodObject<{
    name: z.ZodString;
    parent_organization_uuid: z.ZodOptional<z.ZodString>;
}> = z.object({
    name: z.string().min(1, 'Name is required').max(255, 'Name is too long'),
    parent_organization_uuid: z.string().optional(),
});

export interface MerchantFormData {
    name: string;
    parent_organization_uuid?: string;
    iso_organization_uuid?: string;
}

export const merchantSchema: z.ZodObject<{
    name: z.ZodString;
    parent_organization_uuid: z.ZodOptional<z.ZodString>;
    iso_organization_uuid: z.ZodOptional<z.ZodString>;
}> = z.object({
    name: z.string().min(1, 'Name is required').max(255, 'Name is too long'),
    parent_organization_uuid: z.string().optional(),
    iso_organization_uuid: z.string().optional(),
});

export const organizationStatusSchema: z.ZodType<Status> = z.nativeEnum(Status);

export const editOrgSchema: z.ZodObject<{
    name: z.ZodString;
    status: typeof organizationStatusSchema;
}> = z.object({
    name: z.string().min(1, 'Name is required').max(255, 'Name is too long'),
    status: organizationStatusSchema,
});
